import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-dark" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_6 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_7 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = {
  class: "btn btn-outline-secondary btn-sm dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = { class: "table-responsive mt-3" }
const _hoisted_12 = { class: "table table-bordered" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "table-responsive mt-3" }
const _hoisted_16 = { class: "table table-bordered" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "table-responsive mt-3" }
const _hoisted_20 = { class: "table table-bordered" }
const _hoisted_21 = {
  key: 0,
  class: "table-secondary"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "table-responsive mt-3" }
const _hoisted_25 = { class: "table table-bordered" }
const _hoisted_26 = {
  key: 0,
  class: "table-secondary"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "text-muted" }

import { computed, onMounted, ref, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'

    import { useCriteriaPageQueryV1 } from '@Quest/PortfolioScenarios/queries-vue-composables'

    import type {
        CriteriaPageReadModel,
        CriterionAnalysisReadModel
    } from '@Quest/PortfolioScenarios/readmodels'


    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriteriaPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ''))


    // ======================
    // Query
    // ======================

    const {
        runCriteriaPageQueryV1,
        modelCriteriaPageQueryV1
    } = useCriteriaPageQueryV1(workspaceId, tchProjectId, scenarioId)

    const rm = modelCriteriaPageQueryV1 as Ref<CriteriaPageReadModel | null>


    // ======================
    // Local state
    // ======================

    const criteriaFilter = ref<string>('Objectives')


    // ======================
    // Computed (was class getters)
    // ======================

    const allCriteria = computed<CriterionAnalysisReadModel[]>(() =>
        rm.value?.Criteria ?? []
    )

    const goal = computed<CriterionAnalysisReadModel | null>(() =>
        allCriteria.value.find(c => c.IsGoal) ?? null
    )

    const criteria = computed<CriterionAnalysisReadModel[]>(() =>
    {
        const filter = criteriaFilter.value

        if (filter === 'Objectives')
        {
            return allCriteria.value.filter(a => a.IsTop)
        }
        else if (filter === 'Attributes')
        {
            return allCriteria.value.filter(a => a.IsBottom)
        }
        else if (filter === 'All criteria')
        {
            return allCriteria.value.filter(a => !a.IsGoal)
        }

        return []
    })


    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Portfolio Plan - Criteria"
        runCriteriaPageQueryV1()
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h6", null, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Back to plan ", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, `/#/portfolio-plan/projects/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}`]
                ])
              ]),
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, null, -1 /* CACHED */))
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "mb-5" }, null, -1 /* CACHED */)),
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("form", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", _hoisted_9, _toDisplayString(criteriaFilter.value), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (criteriaFilter.value = 'Objectives'))
                  }, "Objectives (top)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (criteriaFilter.value = 'Attributes'))
                  }, "Attributes (bottom)"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (criteriaFilter.value = 'All criteria'))
                  }, "All criteria")
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "mt-5" }, "1. Criteria weights", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Criteria"),
                    _createElementVNode("th", null, "Local Weight [%]"),
                    _createElementVNode("th", null, "Global Weight [%]")
                  ])
                ], -1 /* CACHED */)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.value, (c) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: c.Id
                    }, [
                      _createElementVNode("td", null, [
                        (!c.IsTop)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              _createElementVNode("small", _hoisted_14, "..." + _toDisplayString(c.Path), 1 /* TEXT */),
                              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(" " + _toDisplayString(c.Name), 1 /* TEXT */)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(c.LocalWeight), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.GlobalWeight), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "mt-5" }, "2. Criteria weights vs. Portfolio value share", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Criteria"),
                    _createElementVNode("th", null, "Weight [%]"),
                    _createElementVNode("th", null, "Value Share [%]"),
                    _createElementVNode("th", null, "Diff [%]")
                  ])
                ], -1 /* CACHED */)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.value, (c) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: c.Id
                    }, [
                      _createElementVNode("td", null, [
                        (!c.IsTop)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _createElementVNode("small", _hoisted_18, "..." + _toDisplayString(c.Path), 1 /* TEXT */),
                              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(" " + _toDisplayString(c.Name), 1 /* TEXT */)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(c.GlobalWeight), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.GlobalValueShare), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.Diff), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "mt-5" }, "3. Project Value Stats", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("table", _hoisted_20, [
                _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { rowspan: "2" }, "Criteria"),
                    _createElementVNode("th", { colspan: "4" }, "Project Value Stats")
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Avg value"),
                    _createElementVNode("th", null, "Min value"),
                    _createElementVNode("th", null, "Max value"),
                    _createElementVNode("th", null, "Std dev")
                  ])
                ], -1 /* CACHED */)),
                _createElementVNode("tbody", null, [
                  (goal.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                        _createElementVNode("td", null, _toDisplayString(goal.value.Name), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.AvgValue), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.MinValue), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.MaxValue), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.StdDev), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.value, (c) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: c.Id
                    }, [
                      _createElementVNode("td", null, [
                        (!c.IsTop)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              _createElementVNode("small", _hoisted_23, "..." + _toDisplayString(c.Path), 1 /* TEXT */),
                              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(" " + _toDisplayString(c.Name), 1 /* TEXT */)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(c.AvgValue), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.MinValue), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.MaxValue), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.StdDev), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "mt-5" }, "4. No. of Projects by Value", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("table", _hoisted_25, [
                _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { rowspan: "2" }, "Criteria"),
                    _createElementVNode("th", { colspan: "5" }, "No. of Projects by Value")
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "0"),
                    _createElementVNode("th", null, "0-25"),
                    _createElementVNode("th", null, "25-50"),
                    _createElementVNode("th", null, "50-75"),
                    _createElementVNode("th", null, "75-100")
                  ])
                ], -1 /* CACHED */)),
                _createElementVNode("tbody", null, [
                  (goal.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                        _createElementVNode("td", null, _toDisplayString(goal.value.Name), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.ScoresCount0), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.ScoresCount1), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.ScoresCount2), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.ScoresCount3), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(goal.value.ScoresCount4), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.value, (c) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: c.Id
                    }, [
                      _createElementVNode("td", null, [
                        (!c.IsTop)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _createElementVNode("small", _hoisted_28, "..." + _toDisplayString(c.Path), 1 /* TEXT */),
                              _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(" " + _toDisplayString(c.Name), 1 /* TEXT */)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(c.ScoresCount0), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.ScoresCount1), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.ScoresCount2), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.ScoresCount3), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(c.ScoresCount4), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})